<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="backgroundFill" height="15" rx="1.5" :stroke="backgroundFill" width="15" x="0.5" y="0.5"/>
    <rect :fill="fill" height="9.8995" transform="rotate(45 8 1)" width="9.8995" x="8" y="1"/>
    <rect :fill="fill" height="10" width="10" x="3" y="3"/>
    <rect :fill="backgroundFill" height="15" rx="1.5" :stroke="backgroundFill" width="15" x="0.5" y="0.5"/>
    <path clip-rule="evenodd" d="M12.3537 4.35355C12.5489 4.15829 12.5489 3.84171 12.3537 3.64645C12.1584 3.45118 11.8418 3.45118 11.6466 3.64645L10.5001 4.79293L9.41425 3.70711L7.45007 4.25708L3.05029 8.65685L7.29293 12.8995L11.6927 8.49972L12.2427 6.53553L11.2072 5.50004L12.3537 4.35355ZM9.50893 5.90627C9.4791 6.06335 9.52498 6.23197 9.64656 6.35355C9.76066 6.46765 9.91617 6.51508 10.0647 6.49584C10.1884 6.84743 10.1096 7.25436 9.82849 7.53551C9.43796 7.92604 8.8048 7.92604 8.41427 7.53551C8.02375 7.14499 8.02375 6.51182 8.41427 6.1213C8.71021 5.82536 9.14549 5.75368 9.50893 5.90627Z" fill="white" fill-rule="evenodd"/>
  </svg>

</template>

<script>
export default {
  name: 'PromotionTag',
  props: {
    width: {
      type: String,
      required: false,
      default: '11px'
    },
    height: {
      type: String,
      required: false,
      default: '11px'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    backgroundFill: {
      type: String,
      required: false,
      default: '#000'
    },
    fill: {
      type: String,
      required: false,
      default: '#FFF'
    },
  },
};

</script>
